import React from 'react';
import { arrayOf, func, number, shape, string } from 'prop-types';
import { Nav, NavItem, OverlayTrigger, Tooltip } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';

import { categoryDetailValidations } from './validations';

export default function PanelTabs({
  categoryDetails,
  categoryOptions,
  selectCategory,
  selectedCategory
}) {
  const handleCategorySelect = (category) => () => selectCategory(category);

  const indicatorIcon = (tooltip, iconOptions) => (
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip id={tooltip}>{tooltip}</Tooltip>}
    >
      <FontAwesome
        name={iconOptions.name}
        tag="i"
        style={{ color: iconOptions.color }}
      />
    </OverlayTrigger>
  );

  return (
    <Nav
      className="category-detail-panel-tab"
      bsStyle="pills"
      stacked
      activeKey={selectedCategory.value}
    >
      {categoryDetails.map((categoryDetail) => {
        const currentCategory = categoryOptions.find(
          (option) => option.value === categoryDetail.category_id
        );
        const detailErrors = categoryDetailValidations(categoryDetail);

        return (
          <NavItem
            id={`tab-${categoryDetail.category_id}`}
            key={categoryDetail.category_id}
            eventKey={categoryDetail.category_id}
            onSelect={handleCategorySelect(currentCategory)}
          >
            <span className="text-left">
              <strong>{currentCategory.label}</strong>
            </span>
            <span className="pull-right">
              {Object.keys(detailErrors).length <= 0
                ? indicatorIcon('Complete', {
                    name: 'check-circle',
                    color: 'green'
                  })
                : indicatorIcon('Missing information', {
                    name: 'exclamation-circle',
                    color: 'red'
                  })}
            </span>
          </NavItem>
        );
      })}
    </Nav>
  );
}

PanelTabs.propTypes = {
  categoryDetails: arrayOf(shape({})).isRequired,
  categoryOptions: arrayOf(shape({})).isRequired,
  selectCategory: func.isRequired,
  selectedCategory: shape({
    label: string,
    value: number
  }).isRequired
};
